import { client } from ".";

async function login(credentials: LoginData) {
	const { data } = await client.post<LoginResponse>(
		"/login",
		credentials
	);
	return data;
}

async function verifyLogin(verificationData: VerifyLoginData) {
	const { data } = await client.post<VerifyLoginResponse>(
		"/verify-login",
		verificationData
	);
	return data;
}

async function resendVerification() {
	const { data } = await client.post<ResendVerificationResponse>(
		"/resend-verification"
	);
	return data;
}

async function logout() {
	const { data } = await client.post<{ message: string }>("/logout");
	return data;
}

const authAPI = {
	login,
	verifyLogin,
	resendVerification,
	logout,
};

export default authAPI;
